import { useStore } from '@/utils/useStore'
import { IPlace, Result } from '@/classes'
import { placeReviewAPI } from '@/api/places'
import ToastsStore from '@/store/toasts'
import UserStore from '@/store/user'
import { sentimentsFollowPlaceAPI } from '~/api/sentiments'

export default defineStore('places', () => {
  const { getItem, getItems, setItem, updateItem, deleteItem } = useStore('place')

  const toastsStore = ToastsStore()
  const userStore = UserStore()

  const { followingPlaces } = storeToRefs(userStore)

  const addReview = async (
    placeId: string,
    review: {
      rating: number
      comment: string
      isAnonymous: boolean
      recommend: '' | 'yes' | 'no' | 'maybe'
      events: '' | 'yes' | 'no' | 'maybe'
      feeling: '' | 'yes' | 'no'
      symbols: '' | 'yes' | 'no'
    }
  ) => {
    const response = await placeReviewAPI(placeId, review)
    if (!response.ok) {
      toastsStore.error(response)
      return response
    }

    if (response.data.place) setItem(response.data.place, { priority: 5 })

    toastsStore.add({ content: useNuxtApp().$i18n.t('components.Place.review.success'), type: 'success' })

    return { data: response.data, ok: true }
  }

  const follow = async (
    placeId: string,
    action?: 'follow' | 'unfollow'
  ) => {
    const response = await sentimentsFollowPlaceAPI(placeId, action ?? 'follow')

    if (response.ok) {
      if (response.data.following) followingPlaces.value = response.data.following
      if (response.data.followerCount !== undefined) {
        updateItem(placeId, {
          followerCount: response.data.followerCount
        })
      }
    }

    return true
  }

  return {
    setItem, deleteItem, addReview,
    getItems, getItem, follow
  }
})